"use client"

import styled from "@emotion/styled"
import { extractProperty, usePreviouslyViewed } from "@eurodrive/utils"
import { Typography } from "@mui/material"
import CarsSwiper from "./CarsSwiper"
import ComparisonBox from "./ComparisonBox"
import Container from "./Container"

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 64px;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding-bottom: 64px;
    text-align: center;
  }
`

const SwiperContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`

export default function PreviouslyViewed({
  data,
  brands,
  title,
  searchPage,
  comparisonBlock,
  noPadding,
}: {
  data?: any
  brands: {
    image: string
    title: string
    logo: string
    url: string
  }[]
  title?: string
  searchPage?: boolean
  comparisonBlock: any
  noPadding?: boolean
}) {
  const { viewedCars } = usePreviouslyViewed({ brands })
  const umbracoTitle = extractProperty(data, "title")
  // Don't render if no cars have been viewed
  if (viewedCars.length === 0) {
    return null
  }

  return (
    <>
      <Container paddingMobile noPadding={noPadding}>
        <StyledContainer>
          <Typography variant="h2">
            {umbracoTitle || title || "רכבים שראית לאחרונה"}
          </Typography>

          <SwiperContainer>
            <CarsSwiper cars={viewedCars.slice(0, 4)} />
          </SwiperContainer>
        </StyledContainer>
      </Container>

      {/* Comparison Box - shows when 2+ cars are selected */}
      <ComparisonBox
        comparisonBlock={comparisonBlock}
        searchPage={searchPage}
      />
    </>
  )
}
